import React from "react";
import SVGButton from "../Buttons/SVGButton";
import { TABLE_CELL_INPUT_MINIMUM_WIDTH } from "../../utilities/constants";
import { useSession } from "../../authentications/SessionContext";
import { primaryColor } from "../../utilities/colors";
import FormikInput from "../Formik/FormikInput";

function ProductAttributeRow({
  index,
  setFieldValue,
  item,
  name,
  disableInputs,
}) {
  const { sessionInfo } = useSession();
  const { isVTEX } = sessionInfo;

  return (
    <tr key={index}>
      <td style={{ minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH }}>
        <FormikInput name={`${name}.${index}.name`} disabled={disableInputs} />
      </td>

      <td style={{ minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH }}>
        <FormikInput name={`${name}.${index}.value`} disabled={disableInputs} />
      </td>
      {!disableInputs && (
        <td className="d-flex  justify-content-center align-items-center mt-auto">
          <SVGButton
            icon={"deleteIcon"}
            hoverColor={isVTEX ? primaryColor.primary : "#ff5837"}
            onClick={() => {
              setFieldValue(`${name}.${index}`, { ...item, isDeleted: true });
            }}
          />
        </td>
      )}
    </tr>
  );
}

export default ProductAttributeRow;
